import { render, staticRenderFns } from "./form-info.vue?vue&type=template&id=7cca85b7&scoped=true&"
import script from "./form-info.vue?vue&type=script&lang=js&"
export * from "./form-info.vue?vue&type=script&lang=js&"
import style0 from "./form-info.vue?vue&type=style&index=0&id=7cca85b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca85b7",
  null
  
)

export default component.exports